let AdminMetaTags = {
    init() {
        const app = new Vue({
            el: "#admin-lenders-edit",
            data() {
                return {
                    metaTags: window.metaTags ? window.metaTags : [{}],
                    form: {
                        name: '',
                        content: ''
                    }
                }
            },
            methods: {
                addRow() {
                    this.metaTags.push({
                        name:'',
                        content:''
                    })
                },
                removeRow(index) {
                    this.metaTags.splice(index, 1);
                },
            },
        })
    }
};

export default AdminMetaTags;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/AdminMetaTags.js